import { Component, computed, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ConfirmationDialogDirective } from '@xmedical/ui';
import { MedicationDisplayItem, MedicationRemovedEvent } from './medication-widget-view/medication-widget-view.component';
import { hasReferralInfo, formatReferralSource } from '../../types/referral-info';

@Component({
  selector: 'xm-medication-list-view',
  imports: [
    DatePipe,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    ConfirmationDialogDirective
  ],
  templateUrl: './medication-list-view.component.html',
  styleUrls: ['./medication-list-view.component.scss']
})
export class MedicationListViewComponent {
  items = input<MedicationDisplayItem[]>([]);
  readonly = input<boolean>(true);
  usePrimaryText = input<boolean>(false);
  emptyMessage = input<string>('No medication items have been added.');

  itemRemoved = output<MedicationRemovedEvent>();

  hasItems = computed(() => this.items().length > 0);

  onRemoveItem(item: MedicationDisplayItem, index: number): void {
    this.itemRemoved.emit({ item, index });
  }

  isReferred(item: MedicationDisplayItem): boolean {
    return hasReferralInfo(item);
  }

  getReferralText(item: MedicationDisplayItem): string {
    return formatReferralSource(item);
  }

  hasDuplicates(item: MedicationDisplayItem): boolean {
    return this.items().some(m => {
      if (m.description.length > item.description.length) {
        return m.description.indexOf(item.description) > -1 && m.id !== item.id;
      } else if (m.description.length < item.description.length) {
        return item.description.indexOf(m.description) > -1 && m.id !== item.id;
      } else {
        return m.description === item.description && m.id !== item.id;
      }
    });
  }

  hasDuplicateTypes(item: MedicationDisplayItem): boolean {
    if (item.typeId === undefined || item.typeUnassigned) {
      return false;
    }
    return this.items().some(m => {
      return m.typeId !== undefined && item.typeId === m.typeId && item.id !== m.id;
    });
  }
}
